import React from 'react';
import {useStyles, Logo, Arrow} from './helper';

const Header = () => {
    const classes = useStyles();
    const referral = localStorage.getItem('referral')
    
    return (
        <div className={classes.root}>
            {/* <div className={classes.wrapLeft}>
                <div>
                    <Logo />
                </div>
                <div className={classes.wrapTitle}>
                    <span className={classes.title}>
                        WIN777
                    </span>
                    <span className={classes.title}>
                        Здесь удача будет всем!
                    </span>
                </div>
            </div> */}
        </div>
    )
}

export default Header;